import { Component, Input,EventEmitter, Output, ViewChild} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { STEP2 } from '@interfaces/motor';
import { Store } from '@ngxs/store';
import { CpSameAgentInfoComponent } from '@shared/components/modal/cp-same-agent-info/cp-same-agent-info.component';
import { CLIENTTYPE, CONSTANTS, IDTYPE, REGEX } from '@shared/enums/index.enum';
import { BrnoService } from '@shared/services/brno/brno.service';
import { NricService } from '@shared/services/nric/nric.service';
import { SharedModule } from '@shared/shared.module';
import { Subject, takeUntil } from 'rxjs';
import { SmeCertFormComponent } from '../sme-cert-form/sme-cert-form.component';
import { SstFormDetailsComponent } from '../sst-form-details/sst-form-details.component';
import { GET_POSTCODE_INFO, UPDATE_GEO_INDICATOR } from '@store/sat-motor/sat-motor.action';
import { GET_PRODUCT_CONFIG_LOV } from '@store/sat-motor/sat-motor.action';
import { BranchesMapComponent } from '@shared/components/branches-map/branches-map.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import { LayoutBreakPointsService } from '@shared/services/layout-break-points/layout-break-points.service';
import { emailValidator } from '@shared/classes/validators/email.validator';

@Component({
  selector: 'app-customer-partner-form',
  standalone: true,
  imports: [
    SharedModule,
    SmeCertFormComponent,
    SstFormDetailsComponent,
    CpSameAgentInfoComponent,
    BranchesMapComponent,
    NxMomentDateModule
  ],
  templateUrl: './customer-partner-form.component.html',
  styleUrl: './customer-partner-form.component.scss'
})
export class CustomerPartnerFormComponent {
  @Input() customerPartnerForm: FormGroup;
  @Input() lov: any;
  @Input() dataDetails: any;
  @Input() eInvoiceConsent: boolean = false;
  @Input() edocConsentInd: boolean = false;
  @Input() mkagAgent: any;
  @Input() isCompOrCustInfoIncomplete: boolean;
  @Input() isContactInfoIncomplete: boolean;
  @Input() isCorrespondenceInfoIncomplete: boolean;
  @Input() cpType: any;

  @ViewChild(BranchesMapComponent) child!: BranchesMapComponent;
  search_mode_address: boolean = true;

  isShow : boolean;
  motorPC : any;
  lovproductConfig:any;
  productAccessListData: any;
  lovPC : any;
  lovGeo: any;
  emailCheck : any;

  idType2List: any;
  cpSameAgentInfoModal?: NxModalRef<CpSameAgentInfoComponent>;

  getCountry = CONSTANTS.getCountry();

  unsubscribe$ = new Subject<void>();

  mobileView: boolean = false;

  idValue2Length: number;
  onlyNumber: boolean = false;
  contactNoRegex: RegExp = new RegExp(REGEX.CONTACT_NO);
  fixedLineNoRegex: RegExp = new RegExp(REGEX.FIXED_LINE_NO);

  cCentricInfo: any;
  isCCentricIssuance: boolean = false;

  atLeastMobileNoOrFixedLineNoStatus: boolean = true;

  unitAddress1MaxErr: boolean = false;

  constructor(
    private readonly dialogService: NxDialogService,
    private nricService: NricService,
    private brnoService: BrnoService,
    private store: Store,
    private layoutService: LayoutBreakPointsService,
  ) {}

  ngOnInit() {
    this.layoutService.subscribeLayoutChanges().subscribe(() => {
      this.mobileView = !this.layoutService.renderDesktop();
    });

    this.cCentricInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState?.cCentricInfo);
    this.isCCentricIssuance = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCCentricIssuance);

    this.initIdType2List();

    this.onChangeIdType2();
    this.initAddressValidators();


    if((this.cpType === "NOT_FOUND" && this.dataDetails.clientType === CLIENTTYPE.INDIVIDUAL && this.dataDetails.idType1 === IDTYPE.NRIC)
    || (this.cpType === "INCOMPLETE" && this.dataDetails.clientType === CLIENTTYPE.INDIVIDUAL && this.dataDetails.idType1 === IDTYPE.NRIC && !this.dataDetails.clientGender)) {
      this.dafaultGender();
    }

    if(this.cpType === "INCOMPLETE" && this.dataDetails?.clientType === CLIENTTYPE.INDIVIDUAL 
      && this.dataDetails?.clientDateofBirth && !this.dataDetails?.clientAge ) {
      this.defaultAge();
    }

    this.onChangeDOB();

    this.motorPC = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    this.lovproductConfig = this.lov.productAccessConfigList;

    
    for (let i = 0; i < this.lovproductConfig.length; i++) {
    this.productAccessListData = this.lovproductConfig[i];
    this.lovPC = Object.keys( this.productAccessListData)[0]; 
  
      if (this.lovPC === this.motorPC) {
       this.lovGeo =this.productAccessListData[this.lovPC].geocodingEnableSat;
       this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;

        if(this.lovGeo == "true")
          {
            this.isShow = true;
          }
          else{
            this.isShow = false;
          }
      }
  }
  this.initValidators();

  if(this.cpType === "INCOMPLETE") {
    this.correctMobileFixedFaxCode();
  }

    if(this.cpType === "INCOMPLETE" || this.isCcentricCPNotFound()) {
      this.onChangeMobileNo(true);
      this.onChangefixedLineNo();
      if(this.showIdType2AndIdValue2()) {
        this.setIdValue2Length();
        this.checkIdValue2IsOnlyNumber();
      }
    }

    if(this.isCCentricIssuance) {
      this.onChangePostcode();
    }
  }

  initIdType2List() {
    if(this.dataDetails.clientType === CLIENTTYPE.INDIVIDUAL) {
      if(this.dataDetails.idType1 === IDTYPE.OLD_IC) {
         this.idType2List = [
          { code: IDTYPE.NRIC, descp: IDTYPE.NRIC_DESCP },
          { code: IDTYPE.POL, descp: IDTYPE.POL_DESCP }
        ]
      }
    }else {
      if(this.dataDetails.idType1 === IDTYPE.BR_NO) {
        this.idType2List = [
         { code: IDTYPE.NEW_BR_NO, descp: IDTYPE.NEW_BR_NO_DESCP }
       ]
     }else {
      this.idType2List = [
        { code: IDTYPE.BR_NO, descp: IDTYPE.BR_NO_DESCP }
      ]
     }
    }
  }

  initValidators() {
    this.initEmailValidators();

    if(this.isCompany) {
      this.initCompanyValidators();
    }else {
      this.initIndividualValidators();
    }
  }

  initEmailValidators() {
    if((this.emailCheck =="true") ||(this.eInvoiceConsent)) {
      this.customerPartnerForm.controls['email'].setValidators([Validators.required, emailValidator]);
    }
  }

  initCompanyValidators() {

    if (this.eInvoiceConsent) {
      this.customerPartnerForm.controls['tinNo'].addValidators(Validators.required);
    }
    this.customerPartnerForm.controls['nationality'].setValidators(Validators.required);
  }

  initIndividualValidators() {
    this.customerPartnerForm.controls['maritalStatus'].setValidators(Validators.required);
    this.customerPartnerForm.controls['gender'].addValidators([Validators.required]);
    if(this.dataDetails.idType1 === IDTYPE.PASS) {
      this.customerPartnerForm.controls['nationality'].setValidators(Validators.required);
    }

    if(this.dataDetails.idType1 !== IDTYPE.NRIC) {
      this.customerPartnerForm.controls['dob'].setValidators(Validators.required);
    }
    this.customerPartnerForm.controls['mobileNo'].addValidators([Validators.required]);
  }

  initAddressValidators(){
    this.customerPartnerForm.controls['postCode'].setValidators(Validators.required);
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  changeSearchMode(event: any) {
    if (event.value == "address") {
      this.search_mode_address = true;
    } else {
      this.search_mode_address = false;
    }
  }

  onBlurIdValue2(idValue2) {
    console.log("idValue2: ", idValue2)
    let idValue2Control = this.customerPartnerForm.controls['idValue2'];
    let idType2Control = this.customerPartnerForm.controls['idType2'];
    let idValue2Val = idValue2Control.value;
    let idType2Val = idType2Control.value;

    if (idValue2Val) {
      idValue2Control.clearValidators();
      switch (idType2Val) {
        case IDTYPE.NRIC:
          if (idValue2Val.length === 12) {
            const isValidNric = this.nricService.isNRICValid(idValue2Val);
            if (!isValidNric) {
              idValue2Control.setErrors({ 'wrongNricFormat': true });
            }else {
              this.customerPartnerForm.get('dob').setValue(this.getDateOfBirth(idValue2Val));
              this.customerPartnerForm.get('gender').setValue(this.nricService.autoPopulateGenderBasedOnNRIC(idValue2Val));
            }
          }else {
            idValue2Control.setErrors({ 'wrongNricFormat': true });
          }
          break;
        
        case IDTYPE.NEW_BR_NO:
          if(idValue2Val.length < 12) {
            idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
          }else {
            try {
              const isValidNewBrNo = this.brnoService.isBRNOValid(idValue2Val);
              if (!isValidNewBrNo) {
                idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
              }
            }catch (err) {
              idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
            }
            
          }
          break;
      }
      idType2Control.setValidators([Validators.required]);
    }else {
      idType2Control.removeValidators([Validators.required]);
    }
    idType2Control.updateValueAndValidity();
  }

  onChangeIdType2() {
    this.customerPartnerForm.controls['idType2'].valueChanges
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(value => {
      let idValue2Control = this.customerPartnerForm.controls['idValue2'];
      let idValue2Val = idValue2Control.value;
      if(value && !idValue2Val) {
        idValue2Control.setErrors({'required': true});        
      }
    });
  }

  dafaultGender() {
    let idValue = this.dataDetails.idValue1;
    let gender = this.nricService.autoPopulateGenderBasedOnNRIC(idValue);
    this.customerPartnerForm.controls['gender'].setValue(gender);
  }

  getErrorType(errors) {
    if (errors.wrongNricFormat) {
      return 'wrongNricFormat';
    }

    if(errors.wrongNewBrnoFormat) {
      return 'wrongNewBrnoFormat';
    }

    if (errors.invalidDOB) {
      return 'invalidDOB';
    }

    if (errors.required) {
      return 'required';
    }

    return false;
  }

  onChangeDOB() {
    this.customerPartnerForm.controls['dob'].valueChanges
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(value => {
      let dobDate = new Date(value);
      const currentDate = new Date();
      
      currentDate.setHours(0,0,0,0);

      let dobYear = dobDate.getFullYear();
      let currentYear = currentDate.getFullYear();

      if(dobYear >= currentYear) {
        this.customerPartnerForm.controls['dob'].setErrors({'invalidDOB': true});
      }else {
        let age = currentYear - dobYear;
        this.customerPartnerForm.controls['age'].setValue(age);
      }
    });
  }

  onChangeAge() {
    console.log("age: ", this.customerPartnerForm.controls['age'].errors);
  }

  onChangeMobileNo(fromInit) {
    let mobileNo = this.customerPartnerForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerPartnerForm.controls['mobileNoCode'].value;
    if(mobileNo) {
      this.customerPartnerForm.controls['mobileNoCode'].setValidators([Validators.required]);

      if(!this.contactNoRegex.test(mobileNo)) {
        this.customerPartnerForm.controls['mobileNo'].setErrors({ pattern: true });
        return;
      }

      if(!fromInit && mobileNo && mobileNoCode) {
        this.checkIsSameAgentMobile();
      }
    }else {
      this.customerPartnerForm.controls['mobileNoCode'].removeValidators([Validators.required]);
    }
    this.customerPartnerForm.controls['mobileNoCode'].updateValueAndValidity();
    
  }

  onChangeEmail() {
    let email = this.customerPartnerForm.controls['email'].value;
    if(email) {
      this.checkIsSameAgentEmail();
    }
    this.customerPartnerForm.controls['email'].updateValueAndValidity();
    
  }

  onChangefixedLineNo() {
    let fixedLineNo = this.customerPartnerForm.controls['fixedLineNo'].value;
    this.customerPartnerForm.controls['fixedLineNoCode'].clearValidators();
    if(fixedLineNo) {
      this.customerPartnerForm.controls['fixedLineNoCode'].setValidators([Validators.required]);

      if(!this.fixedLineNoRegex.test(fixedLineNo)) {
        this.customerPartnerForm.controls['fixedLineNo'].setErrors({ pattern: true });
        return;
      }

    }else {
      this.customerPartnerForm.controls['fixedLineNoCode'].removeValidators([Validators.required]);
    }
    this.customerPartnerForm.controls['fixedLineNoCode'].updateValueAndValidity();
  }

  onChangeFaxNo() {
    let faxNo = this.customerPartnerForm.controls['faxNo'].value;
    this.customerPartnerForm.controls['faxNoCode'].clearValidators();
    if(faxNo) {
      this.customerPartnerForm.controls['faxNoCode'].setValidators([Validators.required]);

      if(!this.contactNoRegex.test(faxNo)) {
        this.customerPartnerForm.controls['faxNo'].setErrors({ pattern: true });
        return;
      }

    }
    this.customerPartnerForm.controls['faxNoCode'].updateValueAndValidity();  
  }

  getDateOfBirth(value) {
    return this.nricService.getDateOfBirth(value);
  }

  getAge(value) {
    return this.nricService.getAge(value);
  }

  openCPSameAgentInfoModal(type) {
    let message = "";
    if(type === "MOBILE") {
      message = "The mobile number you have keyed in is an agent's mobile number. If you proceed with this number, it is deemed that you have obtained the customer's consent to use this number as the contact number for this policy. Please confirm if this is correct or otherwise key-in the mobile number provided by the customer.";
    }else {
      message = "The email you have keyed in is an agent's email. If you proceed with this email, it is deemed that you have obtained the customer's consent to use this email as the contact email for this policy. Please confirm if this is correct or otherwise key-in the email provided by the customer.";
    }

    this.cpSameAgentInfoModal = this.dialogService.open(CpSameAgentInfoComponent, {
      showCloseIcon: false,
      disableClose: true,
      data: {
        message: message
      },
      width: '400px',
    });

    this.cpSameAgentInfoModal.afterClosed().subscribe(result => {
      if(result != "OK") {
        switch(type) {
          case "MOBILE":
            this.customerPartnerForm.controls['mobileNo'].setValue('');
          break;
          case "EMAIL":
            this.customerPartnerForm.controls['email'].setValue('');
          break;
        }
      }
    });
  }

  showCompOrCustInfoSection() {
    if(this.cpType === "FOUND" || this.cpType === "NOT_FOUND") {
      return true;
    }else {
      return this.dataDetails.updateCustomerPartner || this.isCompOrCustInfoIncomplete;
    }
  }

  showContactSection() {
    if(this.cpType === "FOUND" || this.cpType === "NOT_FOUND") {
      return true;
    }else {
      return this.dataDetails.updateCustomerPartner || this.isCompOrCustInfoIncomplete || this.isContactInfoIncomplete || this.isCorrespondenceInfoIncomplete;
    }
  }

  showCorrespondenceSection () {
    if(this.cpType === "FOUND" || this.cpType === "NOT_FOUND") {
      return true;
    }else {
      return this.dataDetails.updateCustomerPartner || this.isCompOrCustInfoIncomplete || this.isContactInfoIncomplete || this.isCorrespondenceInfoIncomplete;
    }
  }

  onChangePostcode() {
    let postcode = this.customerPartnerForm.controls['postCode'].value;

    this.store.dispatch(new GET_POSTCODE_INFO(postcode)).subscribe(state => {
      let postcodeInfo = state.SatMotorState.data.postCodeInfo;
      this.customerPartnerForm.patchValue({
        state: postcodeInfo.state,
        city: postcodeInfo.city,
        country: "MAL"
      });
    });
  }

  checkIsSameAgentMobile() {
    let mobileNo = this.customerPartnerForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerPartnerForm.controls['mobileNoCode'].value;

    if(!this.isCompany && mobileNoCode == this.mkagAgent.agentMobileCode1 && mobileNo == this.mkagAgent.agentMobileNo1) {
      this.openCPSameAgentInfoModal("MOBILE");
    }
  }

  checkIsSameAgentEmail() {
    let email = this.customerPartnerForm.controls['email'].value;
    if(!this.isCompany && email.toUpperCase() == this.mkagAgent.agentEmail.toUpperCase()) {
      this.openCPSameAgentInfoModal("EMAIL");
    }
  }

  onChangeMobileNoCode() {
    let mobileNo = this.customerPartnerForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerPartnerForm.controls['mobileNoCode'].value;
    if(mobileNo && mobileNoCode) {
      this.checkIsSameAgentMobile();
    }
  }

  validateUnitAddress1MaxLength() {
    let address1Control = this.customerPartnerForm.get("address1");
    let unitNoControl = this.customerPartnerForm.get("unitNo");

    let address1length = address1Control.value ? address1Control.value.length : 0;
    let unitNolength = unitNoControl.value ? unitNoControl.value.length : 0;

    const unitAddress1Length = address1length + unitNolength + 2;

    if (unitAddress1Length > 100) {
      this.unitAddress1MaxErr = true;
      return true;
    }else {
      this.unitAddress1MaxErr = false;
      return false;
    }

  }

  get isCompany() {
    return this.dataDetails.clientType === CLIENTTYPE.COMPANY;
  }

  get isOldIC() {
    return this.dataDetails.idType1 === IDTYPE.OLD_IC;
  }

  get isNric() {
    return this.dataDetails.idType1 === IDTYPE.NRIC;
  }

  get idValue2ErrorType() {
    let errors = this.customerPartnerForm.controls['idValue2'].errors;
    if (!errors) {
      return false;
    }
    return this.getErrorType(errors);
  }

  get dobErrorType() {
    let errors = this.customerPartnerForm.controls['dob'].errors;
    if (!errors) {
      return false;
    }
    return this.getErrorType(errors);
  }

  populateForm(data: any) {
    
    //reset first before populate
    this.customerPartnerForm.patchValue({
      unitNo: '',
      address1: '',
      address2: '',
      address3: '',
      postCode: '',
      city: '',
      state: '',
      country: '',
      clientGeoLatitude : '',
      clientGeoLongitude : '',
      clientGeoPlaceId : '',
      clientGeoPlusCode : '',
      clientGeoFormattedAddress : ''
    });

    this.customerPartnerForm.patchValue({
      unitNo: data.unitNumber,
      address1: data.clientAddress1,
      address2: data.clientAddress2,
      address3: data.clientAddress3,
      postCode: data.clientPostcode,
      clientGeoLatitude : data.clientGeoLatitude,
      clientGeoLongitude : data.clientGeoLongitude,
      clientGeoPlaceId : data.clientGeoPlaceId,
      clientGeoPlusCode : data.clientGeoPlusCode,
      clientGeoFormattedAddress : data.clientGeoFormattedAddress
    });

    if (data.clientPostcode) {
      this.onChangePostcode();
    } else {
      this.customerPartnerForm.patchValue({
        city: data.clientCityDesc,
        state: data.clientStateDesc,
        country: data.clientCountryDesc,
      });
    }
  }

  //reset Address to null
  clearAddress(){
      
    this.customerPartnerForm.controls['address1'].clearValidators();
    this.customerPartnerForm.controls['postCode'].clearValidators();
    
    this.customerPartnerForm.controls['address1'].updateValueAndValidity();
    this.customerPartnerForm.controls['postCode'].updateValueAndValidity();

    this.customerPartnerForm.patchValue({
      unitNo: '',
      address1: '',
      address2: '',
      address3: '',
      postCode: '',
      city: '',
      state: '',
      country: '',
      showMapSwitcher:[true],
      clientGeoLatitude : '',
      clientGeoLongitude : '',
      clientGeoPlaceId : '',
      clientGeoPlusCode : '',
      clientGeoFormattedAddress : ''
    });

    this.dataDetails ={
      ...this.dataDetails,
      clientAddress1:'',
      clientAddress1Tmp: '',
      clientAddress2:'',
      clientAddress3:'', 
      clientCity:'',
      clientCountry:'',
      clientGeoLatitude:'',
      clientGeoLongitude:'',
      clientGeoPlaceId:'',
      clientGeoPlusCode:'',
      clientPostcode:'',
      clientState:'',
      clientUnitNo:'',
    };
    this.child.clearAddress();
    this.store.dispatch(new UPDATE_GEO_INDICATOR(false));

  }

  idType2OnChange() {
    this.customerPartnerForm.controls['idValue2'].reset();

    this.setIdValue2Length();

    this.checkIdValue2IsOnlyNumber();
  }

  setIdValue2Length() {
    let value = this.customerPartnerForm.controls['idType2'].value;
    if (value === IDTYPE.NRIC || value === IDTYPE.NEW_BR_NO) {
      this.idValue2Length = 12;
    } else {
      this.idValue2Length = 20;
    }
  }

  checkIdValue2IsOnlyNumber() {
    let value = this.customerPartnerForm.controls['idType2'].value;
    if(value === IDTYPE.NRIC) {
      this.onlyNumber = true;
    }else {
      this.onlyNumber = false;
    }
  }

  showIdType2AndIdValue2() {
    return (!this.isCompany && this.isOldIC) || this.isCompany;
  }

  isCcentricCPNotFound() {
    return this.cCentricInfo && this.isCCentricIssuance && this.cpType === "NOT_FOUND";
  }

  validateForm() {
    let valid = true;

    //validate company at least mobile no or fixed line no
    let mobileNo = this.customerPartnerForm.get('mobileNo').value;
    let fixedLineNo = this.customerPartnerForm.get('fixedLineNo').value;

    if(this.isCompany) {
      if(!mobileNo && !fixedLineNo) {
        this.atLeastMobileNoOrFixedLineNoStatus = false;
        valid = false;
        return valid;
      }else {
        this.atLeastMobileNoOrFixedLineNoStatus = true;
      }
    }

    if(this.validateUnitAddress1MaxLength()) {
      valid = false;
      return valid;
    }else {
      valid = true;
    }

    return valid;
  }

  correctMobileFixedFaxCode() {
        // Automatically update mobileCode, fixedLineCode, and faxCode to format 60XX when possible
        const mobileCodeList = this.lov.clientMobileCode1List;
        const fixedCodeList = this.lov.clientFax1CodeList;
        const faxCodeList = this.lov.clientFax1CodeList;
    
        if (this.dataDetails?.clientMobileCode1) {
          let existingMobileCode = mobileCodeList?.find(code => this.dataDetails.clientMobileCode1 == code.code);
          if (!existingMobileCode) {
            let tempMobileCode = '6' + this.dataDetails.clientMobileCode1;
            existingMobileCode = mobileCodeList?.find(code => tempMobileCode == code.code);
            if (!existingMobileCode) {
              this.customerPartnerForm.patchValue({
                mobileNoCode: ''
              });
            } else {
              this.customerPartnerForm.patchValue({
                mobileNoCode: existingMobileCode.code
              });
            }
          }
        }
    
        if (this.dataDetails?.clientPartnerAddress?.clientPhoneCode) {
          let existingFixedLineCode = fixedCodeList?.find(code => this.dataDetails.clientPartnerAddress.clientPhoneCode == code.code);
          if (!existingFixedLineCode) {
            let tempFixedLineCode = '6' + this.dataDetails.clientPartnerAddress.clientPhoneCode;
            existingFixedLineCode = fixedCodeList?.find(code => tempFixedLineCode == code.code);
            if (!existingFixedLineCode) {
              this.customerPartnerForm.patchValue({
                fixedLineNoCode: ''
              });
            } else {
              this.customerPartnerForm.patchValue({
                fixedLineNoCode: existingFixedLineCode.code
              });
            }
          }
        }
    
        if (this.dataDetails?.clientPartnerAddress?.clientFax1Code) {
          let existingFaxCode = faxCodeList?.find(code => this.dataDetails.clientPartnerAddress.clientFax1Code == code.code);
          if (!existingFaxCode) {
            let tempFaxCode = '6' + this.dataDetails.clientPartnerAddress.clientFax1Code;
            existingFaxCode = faxCodeList?.find(code => tempFaxCode == code.code);
            if (!existingFaxCode) {
              this.customerPartnerForm.patchValue({
                faxNoCode: ''
              });
            } else {
              this.customerPartnerForm.patchValue({
                faxNoCode: existingFaxCode.code
              });
            }
          }
        }
  }

  defaultAge() {
    let calculateAge = this.getCalculateLatestAge();
    this.customerPartnerForm.get("age").setValue(calculateAge);
  }

  getCalculateLatestAge() {
    if (this.dataDetails.clientType === CLIENTTYPE.INDIVIDUAL && this.dataDetails.clientDateofBirth) {
      const dateObject = new Date(this.dataDetails.clientDateofBirth);
      if (!isNaN(dateObject.getTime())) {
        const birthYear = dateObject.getFullYear();
        const currentYear = new Date().getFullYear();
        return currentYear - birthYear;
      } else {
        //Invalid date format in clientDateofBirth
        return null;
      }
    } else {
      return null;
    }
  }
}
